<template xmlns="http://www.w3.org/1999/html" lang="pug">
  .main-block
    .container
      .block-project
        .block-project__logo
          img(src="./assets/logo.svg")
        .block-project__title
          | Booster votre projet innovant
          br
          | avec un partenaire
      .block-footer
         .block-footer__content
           | Site en cours de mise à jour.
           br
           | Pour obtenir plus d’informations ou monter votre
           br
           | dossier de financement contactez
         .block-footer__email
           .logo-arrow
              img.arrow(src="./assets/arrow.svg")
           a.block-footer__email(href="mailto:yannick@ob-vious.com")
             | yannick@ob-vious.com
</template>

<script>
export default {
  name: 'app',
  data () {
    return {

    }
  }
}
</script>

<style lang="sass">
@import '~bootstrap/scss/_functions'
@import '~bootstrap/scss/_variables'
@import '~bootstrap/scss/mixins/_breakpoints'
@import url('https://fonts.googleapis.com/css?family=Montserrat:400,500,700&subset=cyrillic,cyrillic-ext,latin-ext,vietnamese')
$font: Montserrat, Helvetica, sans-serif


body
  margin: 0

.main-block
  display: flex
  background: linear-gradient(to bottom, #02343e, #001317)

.container
  min-height: 100vh
  width: 100%
  display: flex
  flex-direction: column
  align-items: center
  justify-content: space-between
  padding: 0 16px

.block-project
  color: #009fc1
  font-family: $font
  font-weight: 500
  text-align: center
  font-size: 48px
  line-height: 1.33
  +media-breakpoint-down(sm)
    font-size: 32px
  &__title
    padding-top: 104px
    +media-breakpoint-down(sm)
      padding-top: 52px
  &__logo
    margin-top: 80px
    +media-breakpoint-down(sm)
      margin-top: 32px

.block-footer
  position: relative
  text-align: center
  font-family: $font
  font-size: 18px
  padding-top: 48px
  padding-bottom: 88px
  +media-breakpoint-down(sm)
    font-size: 16px
    padding-bottom: 46px
  &__content
    text-align: center
    color: #ffffff
    line-height: 1.56
  &__email
    font-weight: bold
    color: #009fc1
    text-decoration: none

.logo-arrow
  width: 106px
  height: 138px
  position: absolute
  bottom: 96px
  left: -40px
  +media-breakpoint-down(sm)
    left: -72px
    bottom: 58px
</style>



// WEBPACK FOOTER //
// src/App.vue